'use client';

import { c as _c } from "react/compiler-runtime";
import { useId, useState } from 'react';
import { cn } from '@ncai-axe/react-ui-v3';
import CheckIcon from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_check.svg';
import styles from './ModuleCheckbox.module.scss';
interface CheckboxProps extends Omit<React.ComponentPropsWithRef<'input'>, 'size'> {
  size?: '24' | '32';
  defaultChecked?: boolean;
}
const ModuleCheckbox = t0 => {
  const $ = _c(30);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      size: t1,
      disabled: t2,
      defaultChecked: t3,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? "32" : t1;
  const disabled = t2 === undefined ? false : t2;
  const defaultChecked = t3 === undefined ? false : t3;
  const reactId = useId();
  const id = props.id ?? reactId;
  const [internalChecked, setInternalChecked] = useState(defaultChecked ?? false);
  const isControlled = props.checked !== undefined;
  const currentChecked = isControlled ? props.checked : internalChecked;
  let t4;
  if ($[6] !== isControlled || $[7] !== props) {
    t4 = e => {
      if (!isControlled) {
        setInternalChecked(e.target.checked);
      }
      props.onChange?.(e);
    };
    $[6] = isControlled;
    $[7] = props;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleChange = t4;
  let t5;
  if ($[9] !== currentChecked || $[10] !== disabled) {
    t5 = () => {
      if (disabled) {
        return currentChecked ? styles.disabledSelected : styles.disabled;
      }
      return currentChecked ? styles.selected : styles.enabled;
    };
    $[9] = currentChecked;
    $[10] = disabled;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const getStateClass = t5;
  let t6;
  if ($[12] !== size) {
    t6 = () => {
      switch (size) {
        case "24":
          {
            return styles.size24;
          }
        case "32":
          {
            return styles.size32;
          }
        default:
          {
            return styles.size32;
          }
      }
    };
    $[12] = size;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const getSizeClass = t6;
  let t7;
  if ($[14] !== className || $[15] !== getSizeClass || $[16] !== getStateClass) {
    t7 = cn(styles.checkbox, getSizeClass(), getStateClass(), className);
    $[14] = className;
    $[15] = getSizeClass;
    $[16] = getStateClass;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== currentChecked || $[19] !== disabled || $[20] !== handleChange || $[21] !== id || $[22] !== props) {
    t8 = <input id={id} type="checkbox" checked={currentChecked} disabled={disabled} className={styles.hiddenInput} onChange={handleChange} {...props} />;
    $[18] = currentChecked;
    $[19] = disabled;
    $[20] = handleChange;
    $[21] = id;
    $[22] = props;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CheckIcon className={styles.checkIcon} width={16.5} height={16.5} />;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== currentChecked || $[26] !== disabled || $[27] !== t7 || $[28] !== t8) {
    t10 = <span className={t7} aria-checked={currentChecked} aria-disabled={disabled}>{t8}{t9}</span>;
    $[25] = currentChecked;
    $[26] = disabled;
    $[27] = t7;
    $[28] = t8;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};
export default ModuleCheckbox;